function OPSpinner(props){
   const {size = ''} = props;

   return (<>
      <div className={"lds-dual-ring "+size}> </div>
   </>);
}
export default OPSpinner;